import { useSelector } from 'react-redux';

import selectors from '@/ui/flux/selectors';

function useTestnetsEnabled() {
  return useSelector<unknown, boolean>(selectors.testnets.enabled);
}

export default useTestnetsEnabled;
